const en = {
    idioma: "Language",
    idiomas: {
        en: "English",
        es: "Spanish",

    },
    home: {
        repoInv: "Researcher's repository",
        uAcademica: "Academic Units",
        cInvestigacion: "Institutional Research centers",
        estadisticas: "Statistics",
        ods: "SDG"
    },
    investigador: {
        nombre: "Name",
        metricas: "Metrics",
        publicaciones: "Publications",
        citaciones: "Citations",
        colaboradores: "Collaborators",
        proyectos: "Projects",
        areas: "Research Areas",
        noareas: "No Areas",
        investigador: "Researcher",
        colaboraciones: "Collaborations"
    },
    unidad: {
        investigadores: "Researchers",
        hombres: "Men",
        mujeres: "Women",

    },
    publicacion: {
        titulo: "Title",
        publicacion: "Publication",
        fecha: "Date",
        journal: "Journal",
        articlenum: "Article num",
        investigadoresEspol: "ESPOL researchers",
        otrosAutEspol: "Others Authors Espol",
        otrosAut: "Other Authors",
        creador: "Creator",
        primerAutor: "First Author",
        anio:"Year"
    },
    proyecto: {
        titulo: "Title",
        proyecto: "Project",
        fechain: "Start Date",
        fechafin: "End Date",
        participante: "Participant",
        nombre : "Name",
        colaboradoresEs: "ESPOL collaborators",
        colaboradoresEx: "External collaborators",
        insEspol: "ESPOL collaborating institutions",
        exInsEspol: "External collaborating institutions",
        rol: "Role",
        area: "Area",
        subarea: "Subarea",
        unidad: "Unit",
        tipoI: "Type",
        institucion: "Institution",
        estado: "Status"
    },
    estadisticas: {
        investigadores: "Researchers",
        pubAnuales: "Annual Publications",
        citAnuales: "Citations Counts",
        proyAnuales: "Current Projects",
        hombres: "Men",
        mujeres: "Women"
    },
    ods: {
        datos: "Data",
        publicaciones: "Publications"
    },
    busqueda: {
        key: "Keywords",
        autor: "Researcher"
    },
};

export default en;